const SCREEN_WIDTH = document.body.clientWidth
const SCREEN_HEIGHT=document.body.scrollHeight

function setTitle(title) {
  document.title = title
  var mobile = navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(mobile)) {
    var iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    // iframe.setAttribute('src', '')
    var iframeCallback = function () {
      setTimeout(function () {
        iframe.removeEventListener('load', iframeCallback)
        document.body.removeChild(iframe)
      }, 0)
    }
    iframe.addEventListener('load', iframeCallback)
    document.body.appendChild(iframe)
  }
}

//将毫秒秒转化为xx小时xx分钟xx秒
function timeStamp( second_time ){  
  var time = parseInt(second_time) + "秒";  
  if( parseInt(second_time )> 60){  
      var second = parseInt(second_time) % 60;  
      var min = parseInt(second_time / 60);  
      time = min + "分" + second + "秒";  
      if( min > 60 ){  
          min = parseInt(second_time / 60) % 60;  
          var hour = parseInt( parseInt(second_time / 60) /60 );  
          time = hour + "小时" + min + "分" + second + "秒";  
    
          if( hour > 24 ){  
              hour = parseInt( parseInt(second_time / 60) /60 ) % 24;  
              var day = parseInt( parseInt( parseInt(second_time / 60) /60 ) / 24 );  
              time = day + "天" + hour + "小时" + min + "分" + second + "秒";  
          }  
      }  
  }  
  return time;          
}  

var obj={
  SCREEN_WIDTH:SCREEN_WIDTH,
  SCREEN_HEIGHT:SCREEN_HEIGHT,
  setTitle:setTitle,
  timeStamp: timeStamp
}
export default obj;